import React from "react";
import { Table } from "react-bootstrap";
import Spinner from "react-bootstrap/Spinner";
import { useTranslation } from "react-i18next";

import { DevModal } from "@components/Helpers";
import { BackendPromise, url_reverse } from "@components/Utils";

export function doFindDuplsPublisher(findStr, setData) {
    setData((prevState) => {
        return {
            ...prevState,
            findStr,
        };
    });
    BackendPromise.post(url_reverse("api:publisher:list"), { find_dupls: findStr }).then((resp) => {
        if (resp.status === "ok") {
            const m = resp.match;
            setData((prevState) => {
                return {
                    ...prevState,
                    findStr,
                    match: m,
                    rows: Array.from(
                        Array(
                            Math.max(m.exactly.length, m.substr.length, m.levenshtein.length, m.phonetic.length)
                        ).keys()
                    ),
                };
            });
        }
    });
}

export function FindDuplsPublisherModal({ data, setData }) {
    const { t } = useTranslation();

    const DevsAndGames = ({ pub }) => (
        <>
            {pub.name}
            <br />
            <a href={url_reverse("admin:publisher:developers", { publisher_id: pub.id })} target="_blank">
                {t("Компании")} ({pub.__developers_cnt})
            </a>
            {" | "}
            <a href={url_reverse("admin:publisher:games", { publisher_id: pub.id })} target="_blank">
                {t("Игры")} ({pub.__games_cnt})
            </a>
        </>
    );

    return (
        <DevModal
            size="xl"
            show={data}
            onHide={() => setData(null)}
            header={data?.findStr}
            body={
                data?.rows ? (
                    <Table hover responsive className="dmg-table">
                        <thead>
                            <tr>
                                <th>{"Поиск точных совпадений по словам"}</th>
                                <th>{"Поиск совпадений подстрок"}</th>
                                <th>{"Алгоритм Левенштейна"}</th>
                                <th>{"Фонетическое совпадение"}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data?.rows?.map((ind) => (
                                <tr key={`object_list${ind}`}>
                                    <td>{data.match.exactly[ind] && <DevsAndGames pub={data.match.exactly[ind]} />}</td>
                                    <td>{data.match.substr[ind] && <DevsAndGames pub={data.match.substr[ind]} />}</td>
                                    <td>
                                        {data.match.levenshtein[ind] && (
                                            <DevsAndGames pub={data.match.levenshtein[ind]} />
                                        )}
                                    </td>
                                    <td>
                                        {data.match.phonetic[ind] && <DevsAndGames pub={data.match.phonetic[ind]} />}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                ) : (
                    <div className="d-flex align-items-center justify-content-center">
                        <Spinner animation="border" variant="primary" role="status" />
                    </div>
                )
            }
        />
    );
}
